import React from 'react';
import { Segment, Tab } from 'semantic-ui-react';
import FileTableContainer from './FileTableContainer';
import UploadForm from './UploadForm';

const HomeTab = ({authUser, fileType}) => (
    <Tab.Pane as="div">
        <Segment>
            <UploadForm authUser={authUser} fileType={fileType} />
        </Segment>
        <FileTableContainer authUser={authUser} fileType={fileType}/>
    </Tab.Pane>
)

export default HomeTab;



// WEBPACK FOOTER //
// ./src/pages/Home/HomeTab.js